module.exports = __webpack_public_path__ + "static/media/brand_white.fe4bcbb6.png";